// extracted by mini-css-extract-plugin
export default {"invoiceNum":"styles_invoiceNum__FjRlI"};